import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InfoIcon from '@mui/icons-material/Info';
import LazyLoad from 'react-lazy-load';

const RadioButtonOptionTemplate = ({ id, imageSrc, title, variablesToolTip, toolTip, subTitle, selected, onSelect, variables, catch_data, globalvariables, classVairiables, classCatch, globalClass, filedata }) => {
    return (
        <div>
            <div role='button' onClick={() => onSelect(id)} className='card-template border-0 mx-1'>
                <div className={`border-0 card ${selected ? 'selected' : ''}`}>
                    <label className={`radio-label ${selected ? 'selected' : ''}`}>
                        <input
                            type="radio"
                            name={subTitle}
                            id={id}
                            className='card-radio mx-2'
                            checked={selected}
                            onChange={() => onSelect(id)}
                        />
                    </label>

                    <div className="card-image border-0">
                        <LazyLoad alt={`Image ${id}`}>
                            <img src={imageSrc} alt={title} />
                        </LazyLoad>
                    </div>

                </div>
                <p className='my-2 text-center card-btm-title'>{title}</p>
            </div>

            <div className={`${classVairiables && classCatch} border-1 template-info bg-card m-2 rounded-4`}>
                <div className={`${classVairiables} d-flex`}>
                    <p className='p-2 mb-0 title-card-template text-center'>Variables in message </p>
                    <OverlayTrigger placement='top' overlay={variablesToolTip}>
                        <InfoIcon className='m-1 ms-auto' />
                    </OverlayTrigger>
                </div>
                <div className={`${classVairiables} line w-100`}></div>
                <ul className={`${classVairiables} list py-2 px-4`}>
                    {variables.map((variable, index) => (
                        <li key={index}>{variable}</li>
                    ))}
                    {globalvariables.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
                <div className={`${classVairiables} ${classCatch} line w-100`}></div>
                <div className={`${classCatch} d-flex`}>
                    <p className='p-2 mb-0 title-card-template text-center'>Data to catch</p>
                    <OverlayTrigger placement='top' overlay={toolTip}>
                        <InfoIcon className='m-1 ms-auto' />
                    </OverlayTrigger>
                </div>
                <div className={`${classCatch} line w-100`}></div>
                <ul className={`${classCatch} list py-2 px-4`}>
                    {catch_data.map((catch_data, index) => (
                        <li key={index}>{catch_data}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default RadioButtonOptionTemplate;
